/**
 * InitializationError
 */ export class InitializationError extends Error {
    constructor(name, message){
        super();
        this.name = "InitializationError";
        this.message = `${name}${message ? ". " + message : ""}`;
    }
}
